import styled from '@emotion/styled';
import React, { useMemo } from 'react';
import { EmojiIcon } from 'views/Conversation/Chat/components/MessageEditor/ToolbarIcon';

export interface StickerTabProps {
  className?: string;
  showEmoji?: boolean;
  tabs: {
    key: string;
    title?: string;
    label?: React.ReactNode;
    thumb: string;
  }[];
  activeTabKey?: string;
  onChange?: (key: string) => void;
}

const Item = styled.div<{ actived?: boolean }>`
  position: relative;
  width: 1em;
  height: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  flex: 0 0 1em;
  cursor: pointer;
  box-sizing: border-box;
  text-align: center;
  border-bottom: 2px solid transparent;
  border-radius: 4px;
  margin: 0 4px;
  > img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 95%;
    vertical-align: middle;
    transform: translateY(-50%) translateX(-50%);
    mix-blend-mode: multiply;
  }
  &:hover {
    background: #fff;
  }
  ${({ actived }) => {
    return actived
      ? {
          background: '#fff',
          // borderBottomColor: 'var(--fett-app-primary-color)',
        }
      : '';
  }}
`;

const Tab = styled.div`
  font-size: 46px;
  line-height: 0;
  display: flex;
  max-width: 100%;
  overscroll-behavior: contain;
  &::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: hsla(0, 0%, 70.6%, 0);
    opacity: 0;
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: hsla(0, 0%, 70.6%, 0.5);
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  overflow-x: auto;
`;

const StickerTab = (props: StickerTabProps) => {
  const { tabs, showEmoji, onChange, activeTabKey, className } = props;
  return (
    <Tab className={className}>
      {useMemo(
        () =>
          tabs.map((tab) => (
            <Item
              key={tab.key}
              actived={tab.key === activeTabKey}
              onClick={() => onChange && onChange(tab.key)}
            >
              {tab.thumb ? <img src={tab.thumb} alt="" /> : tab.label ?? null}
            </Item>
          )),
        [tabs, activeTabKey, onChange],
      )}
      {showEmoji && (
        <Item
          key="emoji"
          actived={'emoji' === activeTabKey}
          onClick={() => onChange && onChange('emoji')}
        >
          <EmojiIcon size={24} />
        </Item>
      )}
    </Tab>
  );
};
export default StickerTab;
